export enum Source {
  'EVA' = 'eva',
  'AMMON' = 'ammon',
  'SIREN' = 'sirene',
}

export const sourceList = [
  Source.AMMON,
  Source.EVA,
  Source.SIREN,
]
